/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from '@tanstack/react-query';
import { useSitContext, queryKeyFn } from './sitContext';
import { deepMerge } from './sitUtils';
import { sitFetch } from './sitFetcher';
/**
 * Delete user account
 */
export const fetchDeleteApiAccount = (variables, signal) => sitFetch({ url: '/accounts/{accountId}', method: 'delete', ...variables, signal });
/**
 * Delete user account
 */
export const useDeleteApiAccount = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiAccount(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update user account
 */
export const fetchPutApiAccount = (variables, signal) => sitFetch({ url: '/accounts/{accountId}', method: 'put', ...variables, signal });
/**
 * Update user account
 */
export const usePutApiAccount = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiAccount(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get user accounts
 */
export const fetchGetApiAccounts = (variables, signal) => sitFetch({ url: '/accounts', method: 'get', ...variables, signal });
export function getApiAccountsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/accounts',
            operationId: 'getApiAccounts',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAccounts(variables, signal),
    };
}
/**
 * Get user accounts
 */
export const useGetApiAccounts = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAccountsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get companies
 */
export const fetchGetApiAdminCompanies = (variables, signal) => sitFetch({ url: '/admin/companies', method: 'get', ...variables, signal });
export function getApiAdminCompaniesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/companies',
            operationId: 'getApiAdminCompanies',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminCompanies(variables, signal),
    };
}
/**
 * Get companies
 */
export const useGetApiAdminCompanies = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminCompaniesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get company by company tree settings id
 */
export const fetchGetApiAdminCompanyByCompanyTreeSettingsId = (variables, signal) => sitFetch({ url: '/admin/companies/{id}', method: 'get', ...variables, signal });
export function getApiAdminCompanyByCompanyTreeSettingsIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/companies/{id}',
            operationId: 'getApiAdminCompanyByCompanyTreeSettingsId',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminCompanyByCompanyTreeSettingsId(variables, signal),
    };
}
/**
 * Get company by company tree settings id
 */
export const useGetApiAdminCompanyByCompanyTreeSettingsId = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminCompanyByCompanyTreeSettingsIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Patch company
 */
export const fetchPatchApiAdminCompany = (variables, signal) => sitFetch({ url: '/admin/companies/{id}', method: 'patch', ...variables, signal });
/**
 * Patch company
 */
export const usePatchApiAdminCompany = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiAdminCompany(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update company entity
 */
export const fetchPatchApiAdminCompanyEntity = (variables, signal) => sitFetch({
    url: '/admin/company-entities/{id}',
    method: 'patch',
    ...variables,
    signal,
});
/**
 * Update company entity
 */
export const usePatchApiAdminCompanyEntity = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiAdminCompanyEntity(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get company users
 */
export const fetchGetApiAdminCompanyUsers = (variables, signal) => sitFetch({
    url: '/admin/companies/{id}/users',
    method: 'get',
    ...variables,
    signal,
});
export function getApiAdminCompanyUsersQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/companies/{id}/users',
            operationId: 'getApiAdminCompanyUsers',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminCompanyUsers(variables, signal),
    };
}
/**
 * Get company users
 */
export const useGetApiAdminCompanyUsers = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminCompanyUsersQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get company tree settings id
 */
export const fetchPostApiAdminCompanyTreeSettingsId = (variables, signal) => sitFetch({
    url: '/admin/company-tree-settings-id',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Get company tree settings id
 */
export const usePostApiAdminCompanyTreeSettingsId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminCompanyTreeSettingsId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Schedule delete company tree settings
 */
export const fetchDeleteApiAdminCompanyTreeSettings = (variables, signal) => sitFetch({
    url: '/admin/company-tree-settings-by-external-unique-id/{id}',
    method: 'delete',
    ...variables,
    signal,
});
/**
 * Schedule delete company tree settings
 */
export const useDeleteApiAdminCompanyTreeSettings = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiAdminCompanyTreeSettings(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get Intacct company info
 */
export const fetchGetApiAdminIntacctCompanyInfo = (variables, signal) => sitFetch({
    url: '/admin/intacct-company-info/{intacctCompanyId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiAdminIntacctCompanyInfoQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/intacct-company-info/{intacctCompanyId}',
            operationId: 'getApiAdminIntacctCompanyInfo',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminIntacctCompanyInfo(variables, signal),
    };
}
/**
 * Get Intacct company info
 */
export const useGetApiAdminIntacctCompanyInfo = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminIntacctCompanyInfoQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Invite admin
 */
export const fetchPostApiAdminInviteAdmin = (variables, signal) => sitFetch({ url: '/admin/invite-admin', method: 'post', ...variables, signal });
/**
 * Invite admin
 */
export const usePostApiAdminInviteAdmin = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminInviteAdmin(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Check if user is authenticated
 */
export const fetchGetApiAdminIsAuthenticated = (variables, signal) => sitFetch({
    url: '/admin/is-authenticated',
    method: 'get',
    ...variables,
    signal,
});
export function getApiAdminIsAuthenticatedQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/is-authenticated',
            operationId: 'getApiAdminIsAuthenticated',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminIsAuthenticated(variables, signal),
    };
}
/**
 * Check if user is authenticated
 */
export const useGetApiAdminIsAuthenticated = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminIsAuthenticatedQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get job status
 */
export const fetchGetApiAdminJobStatus = (variables, signal) => sitFetch({ url: '/admin/job-status', method: 'get', ...variables, signal });
export function getApiAdminJobStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/job-status',
            operationId: 'getApiAdminJobStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminJobStatus(variables, signal),
    };
}
/**
 * Get job status
 */
export const useGetApiAdminJobStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminJobStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Provision company
 */
export const fetchPostApiAdminProvision = (variables, signal) => sitFetch({ url: '/admin/provision', method: 'post', ...variables, signal });
/**
 * Provision company
 */
export const usePostApiAdminProvision = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminProvision(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Check WSU permissions
 */
export const fetchPostApiAdminProvisionTest = (variables, signal) => sitFetch({ url: '/admin/provision-test', method: 'post', ...variables, signal });
/**
 * Check WSU permissions
 */
export const usePostApiAdminProvisionTest = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminProvisionTest(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * List trigger package installations
 */
export const fetchGetApiAdminTriggersPackages = (variables, signal) => sitFetch({ url: '/admin/triggers-packages', method: 'get', ...variables, signal });
export function getApiAdminTriggersPackagesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/triggers-packages',
            operationId: 'getApiAdminTriggersPackages',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminTriggersPackages(variables, signal),
    };
}
/**
 * List trigger package installations
 */
export const useGetApiAdminTriggersPackages = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminTriggersPackagesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Install trigger package
 */
export const fetchPostApiAdminTriggersPackages = (variables, signal) => sitFetch({ url: '/admin/triggers-packages', method: 'post', ...variables, signal });
/**
 * Install trigger package
 */
export const usePostApiAdminTriggersPackages = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminTriggersPackages(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get scheduled jobs
 */
export const fetchGetApiAdminScheduledJobs = (variables, signal) => sitFetch({ url: '/admin/scheduled-jobs', method: 'get', ...variables, signal });
export function getApiAdminScheduledJobsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/scheduled-jobs',
            operationId: 'getApiAdminScheduledJobs',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminScheduledJobs(variables, signal),
    };
}
/**
 * Get scheduled jobs
 */
export const useGetApiAdminScheduledJobs = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminScheduledJobsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Schedule job
 */
export const fetchPostApiAdminScheduleJob = (variables, signal) => sitFetch({ url: '/admin/scheduled-jobs', method: 'post', ...variables, signal });
/**
 * Schedule job
 */
export const usePostApiAdminScheduleJob = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminScheduleJob(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get sync status for company
 */
export const fetchGetApiAdminSyncStatus = (variables, signal) => sitFetch({
    url: '/admin/sync-status/{companyTreeSettingsId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiAdminSyncStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/sync-status/{companyTreeSettingsId}',
            operationId: 'getApiAdminSyncStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminSyncStatus(variables, signal),
    };
}
/**
 * Get sync status for company
 */
export const useGetApiAdminSyncStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminSyncStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Initialize sync tree job for company
 */
export const fetchPostApiAdminSyncTree = (variables, signal) => sitFetch({ url: '/admin/sync-tree', method: 'post', ...variables, signal });
/**
 * Initialize sync tree job for company
 */
export const usePostApiAdminSyncTree = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminSyncTree(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Sync trigger packages
 */
export const fetchPostApiAdminSyncTriggersPackages = (variables, signal) => sitFetch({
    url: '/admin/sync-triggers-packages/{companyTreeSettingsId}',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Sync trigger packages
 */
export const usePostApiAdminSyncTriggersPackages = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminSyncTriggersPackages(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Schedule update Intacct permissions
 */
export const fetchPostApiAdminUpdatePermissions = (variables, signal) => sitFetch({ url: '/admin/update-permissions', method: 'post', ...variables, signal });
/**
 * Schedule update Intacct permissions
 */
export const usePostApiAdminUpdatePermissions = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAdminUpdatePermissions(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get user by user ID
 */
export const fetchGetApiAdminUserById = (variables, signal) => sitFetch({ url: '/admin/users/{id}', method: 'get', ...variables, signal });
export function getApiAdminUserByIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/admin/users/{id}',
            operationId: 'getApiAdminUserById',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAdminUserById(variables, signal),
    };
}
/**
 * Get user by user ID
 */
export const useGetApiAdminUserById = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAdminUserByIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update user primary company
 */
export const fetchPutApiAdminUserCompany = (variables, signal) => sitFetch({ url: '/admin/users/{id}/company', method: 'put', ...variables, signal });
/**
 * Update user primary company
 */
export const usePutApiAdminUserCompany = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiAdminUserCompany(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Set active status for user
 */
export const fetchPatchApiAdminUserSetActiveStatus = (variables, signal) => sitFetch({
    url: '/admin/users/{id}/set-active-status',
    method: 'patch',
    ...variables,
    signal,
});
/**
 * Set active status for user
 */
export const usePatchApiAdminUserSetActiveStatus = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiAdminUserSetActiveStatus(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get allocation templates
 */
export const fetchGetApiAllocationTemplates = (variables, signal) => sitFetch({ url: '/allocation-templates', method: 'get', ...variables, signal });
export function getApiAllocationTemplatesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/allocation-templates',
            operationId: 'getApiAllocationTemplates',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAllocationTemplates(variables, signal),
    };
}
/**
 * Get allocation templates
 */
export const useGetApiAllocationTemplates = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAllocationTemplatesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get allocation template lines by allocation ID
 */
export const fetchGetApiAllocationTemplateLines = (variables, signal) => sitFetch({
    url: '/allocation-templates/{id}/lines',
    method: 'get',
    ...variables,
    signal,
});
export function getApiAllocationTemplateLinesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/allocation-templates/{id}/lines',
            operationId: 'getApiAllocationTemplateLines',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAllocationTemplateLines(variables, signal),
    };
}
/**
 * Get allocation template lines by allocation ID
 */
export const useGetApiAllocationTemplateLines = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAllocationTemplateLinesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Decline timesheet entries asynchronously
 */
export const fetchPutApiApprovalsApproveAsync = (variables, signal) => sitFetch({ url: '/approvals/approve-async', method: 'put', ...variables, signal });
/**
 * Decline timesheet entries asynchronously
 */
export const usePutApiApprovalsApproveAsync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiApprovalsApproveAsync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Decinle timesheet entries asynchronously
 */
export const fetchPutApiApprovalsDeclineAsync = (variables, signal) => sitFetch({ url: '/approvals/decline-async', method: 'put', ...variables, signal });
/**
 * Decinle timesheet entries asynchronously
 */
export const usePutApiApprovalsDeclineAsync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiApprovalsDeclineAsync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get approvals check
 */
export const fetchGetApiApprovalsCheck = (variables, signal) => sitFetch({ url: '/approvals/check', method: 'get', ...variables, signal });
export function getApiApprovalsCheckQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/approvals/check',
            operationId: 'getApiApprovalsCheck',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiApprovalsCheck(variables, signal),
    };
}
/**
 * Get approvals check
 */
export const useGetApiApprovalsCheck = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiApprovalsCheckQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get timesheet approvals
 */
export const fetchGetApiApprovalsTimesheets = (variables, signal) => sitFetch({ url: '/approvals/timesheets', method: 'get', ...variables, signal });
export function getApiApprovalsTimesheetsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/approvals/timesheets',
            operationId: 'getApiApprovalsTimesheets',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiApprovalsTimesheets(variables, signal),
    };
}
/**
 * Get timesheet approvals
 */
export const useGetApiApprovalsTimesheets = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiApprovalsTimesheetsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get timesheet entries to approve
 */
export const fetchGetApiApprovalsEntries = (variables, signal) => sitFetch({ url: '/approvals/entries', method: 'get', ...variables, signal });
export function getApiApprovalsEntriesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/approvals/entries',
            operationId: 'getApiApprovalsEntries',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiApprovalsEntries(variables, signal),
    };
}
/**
 * Get timesheet entries to approve
 */
export const useGetApiApprovalsEntries = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiApprovalsEntriesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get audit log
 */
export const fetchGetApiAuditLog = (variables, signal) => sitFetch({ url: '/audit-log', method: 'get', ...variables, signal });
export function getApiAuditLogQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/audit-log',
            operationId: 'getApiAuditLog',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiAuditLog(variables, signal),
    };
}
/**
 * Get audit log
 */
export const useGetApiAuditLog = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiAuditLogQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * When a user access a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the Intacct access token. This endpoint returns a SIT access token that can be used to access SIT. The SIT access token is then added to a fragment in the URL of the SIT iframe, where it is used to authenticate the user by forwarding the token to the SIT server. The SIT access token is a JWT token that contains the identity of the user, the current entity selected on Intacct, and the expiration time of the token.
 */
export const fetchPostApiAuthIntacctAccessToken = (variables, signal) => sitFetch({
    url: '/auth/intacct-access-token',
    method: 'post',
    ...variables,
    signal,
});
/**
 * When a user access a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the Intacct access token. This endpoint returns a SIT access token that can be used to access SIT. The SIT access token is then added to a fragment in the URL of the SIT iframe, where it is used to authenticate the user by forwarding the token to the SIT server. The SIT access token is a JWT token that contains the identity of the user, the current entity selected on Intacct, and the expiration time of the token.
 */
export const usePostApiAuthIntacctAccessToken = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthIntacctAccessToken(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Refresh the Intacct access token or switch entities
 */
export const fetchPostApiAuthIntacctRefresh = (variables, signal) => sitFetch({ url: '/auth/intacct-refresh', method: 'post', ...variables, signal });
/**
 * Refresh the Intacct access token or switch entities
 */
export const usePostApiAuthIntacctRefresh = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthIntacctRefresh(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Login to SIT with Intacct credentials
 */
export const fetchPostApiAuthLogin = (variables, signal) => sitFetch({ url: '/auth/login', method: 'post', ...variables, signal });
/**
 * Login to SIT with Intacct credentials
 */
export const usePostApiAuthLogin = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthLogin(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Used by the mobile app to exchange an Intacct token for a SIT token. The mobile application uses OAuth 2.0 PKCE to authenticate with Intacct and receive an access token. The mobile application then sends this access token to SIT to receive a SIT token.
 */
export const fetchPostApiAuthLoginWithIntacctToken = (variables, signal) => sitFetch({
    url: '/auth/login-with-intacct-token',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Used by the mobile app to exchange an Intacct token for a SIT token. The mobile application uses OAuth 2.0 PKCE to authenticate with Intacct and receive an access token. The mobile application then sends this access token to SIT to receive a SIT token.
 */
export const usePostApiAuthLoginWithIntacctToken = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthLoginWithIntacctToken(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Login with biometrics
 */
export const fetchPostApiAuthLoginBiometrics = (variables, signal) => sitFetch({ url: '/auth/login/biometrics', method: 'post', ...variables, signal });
/**
 * Login with biometrics
 */
export const usePostApiAuthLoginBiometrics = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthLoginBiometrics(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Submit MFA fallback code
 */
export const fetchPostApiAuthMfaFallback = (variables, signal) => sitFetch({ url: '/auth/mfa-fallback', method: 'post', ...variables, signal });
/**
 * Submit MFA fallback code
 */
export const usePostApiAuthMfaFallback = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiAuthMfaFallback(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Add or remove a calendar from the user's calendar list
 */
export const fetchPutApiCalendarCalendarsId = (variables, signal) => sitFetch({ url: '/calendar/calendars/{id}', method: 'put', ...variables, signal });
/**
 * Add or remove a calendar from the user's calendar list
 */
export const usePutApiCalendarCalendarsId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiCalendarCalendarsId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get clients
 */
export const fetchGetApiClients = (variables, signal) => sitFetch({ url: '/clients', method: 'get', ...variables, signal });
export function getApiClientsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/clients',
            operationId: 'getApiClients',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiClients(variables, signal),
    };
}
/**
 * Get clients
 */
export const useGetApiClients = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiClientsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Delete cluster node
 */
export const fetchDeleteApiCluster = (variables, signal) => sitFetch({ url: '/clusters/{id}', method: 'delete', ...variables, signal });
/**
 * Delete cluster node
 */
export const useDeleteApiCluster = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiCluster(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update cluster node
 */
export const fetchPutApiCluster = (variables, signal) => sitFetch({ url: '/clusters/{id}', method: 'put', ...variables, signal });
/**
 * Update cluster node
 */
export const usePutApiCluster = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiCluster(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Assign a cluster to a row
 */
export const fetchPutApiClusterAssign = (variables, signal) => sitFetch({ url: '/clusters/{id}/assign', method: 'put', ...variables, signal });
/**
 * Assign a cluster to a row
 */
export const usePutApiClusterAssign = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiClusterAssign(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Split a cluster
 */
export const fetchPostApiClusterSplit = (variables, signal) => sitFetch({ url: '/clusters/{id}/split', method: 'post', ...variables, signal });
/**
 * Split a cluster
 */
export const usePostApiClusterSplit = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiClusterSplit(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete cluster node
 */
export const fetchDeleteApiClusterNode = (variables, signal) => sitFetch({
    url: '/clusters/{id}/nodes/{nodeId}',
    method: 'delete',
    ...variables,
    signal,
});
/**
 * Delete cluster node
 */
export const useDeleteApiClusterNode = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiClusterNode(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update cluster node
 */
export const fetchPutApiClusterNode = (variables, signal) => sitFetch({
    url: '/clusters/{id}/nodes/{nodeId}',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Update cluster node
 */
export const usePutApiClusterNode = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiClusterNode(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update overlaps
 */
export const fetchPutApiClusterNodeOverlaps = (variables, signal) => sitFetch({ url: '/clusters/nodes/overlaps', method: 'put', ...variables, signal });
/**
 * Update overlaps
 */
export const usePutApiClusterNodeOverlaps = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiClusterNodeOverlaps(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get clusters for a timesheet
 */
export const fetchGetApiClustersForTimesheet = (variables, signal) => sitFetch({
    url: '/clusters/timesheet/{timesheetId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiClustersForTimesheetQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/clusters/timesheet/{timesheetId}',
            operationId: 'getApiClustersForTimesheet',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiClustersForTimesheet(variables, signal),
    };
}
/**
 * Get clusters for a timesheet
 */
export const useGetApiClustersForTimesheet = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiClustersForTimesheetQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get Intacct entity (SIT company)
 */
export const fetchGetApiCompany = (variables, signal) => sitFetch({ url: '/companies', method: 'get', ...variables, signal });
export function getApiCompanyQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/companies',
            operationId: 'getApiCompany',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiCompany(variables, signal),
    };
}
/**
 * Get Intacct entity (SIT company)
 */
export const useGetApiCompany = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiCompanyQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update company
 */
export const fetchPutApiCompaniesByUuid = (variables, signal) => sitFetch({ url: '/companies/{companyId}', method: 'put', ...variables, signal });
/**
 * Update company
 */
export const usePutApiCompaniesByUuid = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiCompaniesByUuid(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Seed cypress
 */
export const fetchPostApiCypressSeed = (variables, signal) => sitFetch({ url: '/cypress/seed', method: 'post', ...variables, signal });
/**
 * Seed cypress
 */
export const usePostApiCypressSeed = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiCypressSeed(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Teardown cypress
 */
export const fetchPostApiCypressTeardown = (variables, signal) => sitFetch({ url: '/cypress/teardown', method: 'post', ...variables, signal });
/**
 * Teardown cypress
 */
export const usePostApiCypressTeardown = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiCypressTeardown(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get data status
 */
export const fetchGetApiDataStatus = (variables, signal) => sitFetch({ url: '/data-status', method: 'get', ...variables, signal });
export function getApiDataStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/data-status',
            operationId: 'getApiDataStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiDataStatus(variables, signal),
    };
}
/**
 * Get data status
 */
export const useGetApiDataStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiDataStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Seed activities for demo
 */
export const fetchPostApiDemoSettingsSeedActivities = (variables, signal) => sitFetch({
    url: '/demo-settings/seed-activities',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Seed activities for demo
 */
export const usePostApiDemoSettingsSeedActivities = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiDemoSettingsSeedActivities(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get dimensions
 */
export const fetchGetApiDimensions = (variables, signal) => sitFetch({ url: '/dimensions', method: 'get', ...variables, signal });
export function getApiDimensionsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/dimensions',
            operationId: 'getApiDimensions',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiDimensions(variables, signal),
    };
}
/**
 * Get dimensions
 */
export const useGetApiDimensions = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiDimensionsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get employees
 */
export const fetchGetApiEmployees = (variables, signal) => sitFetch({ url: '/employees', method: 'get', ...variables, signal });
export function getApiEmployeesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/employees',
            operationId: 'getApiEmployees',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiEmployees(variables, signal),
    };
}
/**
 * Get employees
 */
export const useGetApiEmployees = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiEmployeesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get overtime calculations for an employee for a specific week
 */
export const fetchGetApiEmployeeOvertimeCalculations = (variables, signal) => sitFetch({
    url: '/employees/{employeeId}/overtime-calculations/{week}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiEmployeeOvertimeCalculationsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/employees/{employeeId}/overtime-calculations/{week}',
            operationId: 'getApiEmployeeOvertimeCalculations',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiEmployeeOvertimeCalculations(variables, signal),
    };
}
/**
 * Get overtime calculations for an employee for a specific week
 */
export const useGetApiEmployeeOvertimeCalculations = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiEmployeeOvertimeCalculationsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Apply overtime calculations to employee timesheets and time clock entries
 */
export const fetchPostApiEmployeeOvertimeCalculationsApply = (variables, signal) => sitFetch({
    url: '/employees/{employeeId}/overtime-calculations/apply',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Apply overtime calculations to employee timesheets and time clock entries
 */
export const usePostApiEmployeeOvertimeCalculationsApply = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiEmployeeOvertimeCalculationsApply(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Run intacct sync
 */
export const fetchGetApiIntacctRunSync = (variables, signal) => sitFetch({ url: '/intacct/run-sync', method: 'get', ...variables, signal });
export function getApiIntacctRunSyncQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/intacct/run-sync',
            operationId: 'getApiIntacctRunSync',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiIntacctRunSync(variables, signal),
    };
}
/**
 * Run intacct sync
 */
export const useGetApiIntacctRunSync = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiIntacctRunSyncQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Run intacct sync
 */
export const fetchPostApiIntacctRunSync = (variables, signal) => sitFetch({ url: '/intacct/run-sync', method: 'post', ...variables, signal });
/**
 * Run intacct sync
 */
export const usePostApiIntacctRunSync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctRunSync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Run Intacct timesheets sync
 */
export const fetchGetApiIntacctRunTimesheetsSync = (variables, signal) => sitFetch({
    url: '/intacct/run-timesheets-sync',
    method: 'get',
    ...variables,
    signal,
});
export function getApiIntacctRunTimesheetsSyncQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/intacct/run-timesheets-sync',
            operationId: 'getApiIntacctRunTimesheetsSync',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiIntacctRunTimesheetsSync(variables, signal),
    };
}
/**
 * Run Intacct timesheets sync
 */
export const useGetApiIntacctRunTimesheetsSync = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiIntacctRunTimesheetsSyncQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Run Intacct timesheets sync
 */
export const fetchPostApiIntacctRunTimesheetsSync = (variables, signal) => sitFetch({
    url: '/intacct/run-timesheets-sync',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Run Intacct timesheets sync
 */
export const usePostApiIntacctRunTimesheetsSync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctRunTimesheetsSync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get Intacct company sync status
 */
export const fetchGetApiIntacctSyncStatus = (variables, signal) => sitFetch({ url: '/intacct/sync-status', method: 'get', ...variables, signal });
export function getApiIntacctSyncStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/intacct/sync-status',
            operationId: 'getApiIntacctSyncStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiIntacctSyncStatus(variables, signal),
    };
}
/**
 * Get Intacct company sync status
 */
export const useGetApiIntacctSyncStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiIntacctSyncStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get Intacct timesheets sync status
 */
export const fetchGetApiIntacctSyncTimesheetsStatus = (variables, signal) => sitFetch({
    url: '/intacct/sync-timesheets-status',
    method: 'get',
    ...variables,
    signal,
});
export function getApiIntacctSyncTimesheetsStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/intacct/sync-timesheets-status',
            operationId: 'getApiIntacctSyncTimesheetsStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiIntacctSyncTimesheetsStatus(variables, signal),
    };
}
/**
 * Get Intacct timesheets sync status
 */
export const useGetApiIntacctSyncTimesheetsStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiIntacctSyncTimesheetsStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * When a user access a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the Intacct access token. This endpoint returns a SIT access token that can be used to access SIT. The SIT access token is then added to a fragment in the URL of the SIT iframe, where it is used to authenticate the user by forwarding the token to the SIT server. The SIT access token is a JWT token that contains the identity of the user, the current entity selected on Intacct, and the expiration time of the token.
 */
export const fetchPostApiIntacctIntegrationAccessToken = (variables, signal) => sitFetch({
    url: '/intacct-integration/access-token',
    method: 'post',
    ...variables,
    signal,
});
/**
 * When a user access a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the Intacct access token. This endpoint returns a SIT access token that can be used to access SIT. The SIT access token is then added to a fragment in the URL of the SIT iframe, where it is used to authenticate the user by forwarding the token to the SIT server. The SIT access token is a JWT token that contains the identity of the user, the current entity selected on Intacct, and the expiration time of the token.
 */
export const usePostApiIntacctIntegrationAccessToken = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctIntegrationAccessToken(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * When an intacct configuration changes (Project configuraiton, for example) and the trigger is not available, Intacct can send a message to SIT to notify the change. This route is used to handle all types of changes.
 */
export const fetchPostApiIntacctIntegrationHandleChange = (variables, signal) => sitFetch({
    url: '/intacct-integration/handle-change',
    method: 'post',
    ...variables,
    signal,
});
/**
 * When an intacct configuration changes (Project configuraiton, for example) and the trigger is not available, Intacct can send a message to SIT to notify the change. This route is used to handle all types of changes.
 */
export const usePostApiIntacctIntegrationHandleChange = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctIntegrationHandleChange(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * On Intacct, when an admin clicks the switch to enable SIT, the following occurs:
 *   1. Intacct creates a set of WSU credentials specifically for SIT
 *   2. Intacct sends a signed message with the WSU credentials (this route)
 *   3. SIT receives the message and verifies the signature
 *   4. SIT schedules a job to provision the company, returning the job information
 *   5. SIT provisions the company
 *   6. (Optional) SIT calls an Intacct endpoint specified in `callback` when the job is complete
 */
export const fetchPostApiIntacctIntegrationProvision = (variables, signal) => sitFetch({
    url: '/intacct-integration/provision',
    method: 'post',
    ...variables,
    signal,
});
/**
 * On Intacct, when an admin clicks the switch to enable SIT, the following occurs:
 *   1. Intacct creates a set of WSU credentials specifically for SIT
 *   2. Intacct sends a signed message with the WSU credentials (this route)
 *   3. SIT receives the message and verifies the signature
 *   4. SIT schedules a job to provision the company, returning the job information
 *   5. SIT provisions the company
 *   6. (Optional) SIT calls an Intacct endpoint specified in `callback` when the job is complete
 */
export const usePostApiIntacctIntegrationProvision = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctIntegrationProvision(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * On Intacct, when an admin clicks the switch to enable SIT, the following occurs:
 *   1. Intacct creates a set of WSU credentials specifically for SIT
 *   2. Intacct sends a signed message with the WSU credentials
 *   3. SIT receives the message and verifies the signature
 *   4. SIT schedules a job to provision the company, returning the job information
 *   5. SIT provisions the company
 *   6. (Optional) SIT calls an Intacct endpoint specified in `callback` when the job is complete
 *
 * This route is called by Intacct to check the status of the job. Since we cannot send a JWT token in the request header,
 */
export const fetchGetApiIntacctIntegrationProvisionJobStatus = (variables, signal) => sitFetch({
    url: '/intacct-integration/provision',
    method: 'get',
    ...variables,
    signal,
});
export function getApiIntacctIntegrationProvisionJobStatusQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/intacct-integration/provision',
            operationId: 'getApiIntacctIntegrationProvisionJobStatus',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiIntacctIntegrationProvisionJobStatus(variables, signal),
    };
}
/**
 * On Intacct, when an admin clicks the switch to enable SIT, the following occurs:
 *   1. Intacct creates a set of WSU credentials specifically for SIT
 *   2. Intacct sends a signed message with the WSU credentials
 *   3. SIT receives the message and verifies the signature
 *   4. SIT schedules a job to provision the company, returning the job information
 *   5. SIT provisions the company
 *   6. (Optional) SIT calls an Intacct endpoint specified in `callback` when the job is complete
 *
 * This route is called by Intacct to check the status of the job. Since we cannot send a JWT token in the request header,
 */
export const useGetApiIntacctIntegrationProvisionJobStatus = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiIntacctIntegrationProvisionJobStatusQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * When a user accesses a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the user's Intacct REST credential using an access token and the OID. This endpoint returns nothing, it's a fire-and-forget operation.
 */
export const fetchPostApiIntacctIntegrationUserRestToken = (variables, signal) => sitFetch({
    url: '/intacct-integration/user-rest-token',
    method: 'post',
    ...variables,
    signal,
});
/**
 * When a user accesses a SIT iframe from Intacct, Intacct's server will send a request to this endpoint with the user's Intacct REST credential using an access token and the OID. This endpoint returns nothing, it's a fire-and-forget operation.
 */
export const usePostApiIntacctIntegrationUserRestToken = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiIntacctIntegrationUserRestToken(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get items
 */
export const fetchGetApiItems = (variables, signal) => sitFetch({ url: '/items', method: 'get', ...variables, signal });
export function getApiItemsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/items',
            operationId: 'getApiItems',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiItems(variables, signal),
    };
}
/**
 * Get items
 */
export const useGetApiItems = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiItemsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get notifications
 */
export const fetchGetApiNotifications = (variables, signal) => sitFetch({ url: '/notifications', method: 'get', ...variables, signal });
export function getApiNotificationsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/notifications',
            operationId: 'getApiNotifications',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiNotifications(variables, signal),
    };
}
/**
 * Get notifications
 */
export const useGetApiNotifications = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiNotificationsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Mark all notifications as read
 */
export const fetchPostApiNotificationsReadAll = (variables, signal) => sitFetch({ url: '/notifications/read-all', method: 'post', ...variables, signal });
/**
 * Mark all notifications as read
 */
export const usePostApiNotificationsReadAll = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiNotificationsReadAll(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get Google OAuth 2.0 token
 */
export const fetchGetApiOauthGoogle = (variables, signal) => sitFetch({ url: '/oauth/google', method: 'get', ...variables, signal });
export function getApiOauthGoogleQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/oauth/google',
            operationId: 'getApiOauthGoogle',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiOauthGoogle(variables, signal),
    };
}
/**
 * Get Google OAuth 2.0 token
 */
export const useGetApiOauthGoogle = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiOauthGoogleQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get Microsoft OAuth 2.0 token
 */
export const fetchGetApiOauthMicrosoft = (variables, signal) => sitFetch({ url: '/oauth/microsoft', method: 'get', ...variables, signal });
export function getApiOauthMicrosoftQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/oauth/microsoft',
            operationId: 'getApiOauthMicrosoft',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiOauthMicrosoft(variables, signal),
    };
}
/**
 * Get Microsoft OAuth 2.0 token
 */
export const useGetApiOauthMicrosoft = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiOauthMicrosoftQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get overtime rulesets
 */
export const fetchGetApiOvertimeRulesets = (variables, signal) => sitFetch({ url: '/overtime-rulesets', method: 'get', ...variables, signal });
export function getApiOvertimeRulesetsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/overtime-rulesets',
            operationId: 'getApiOvertimeRulesets',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiOvertimeRulesets(variables, signal),
    };
}
/**
 * Get overtime rulesets
 */
export const useGetApiOvertimeRulesets = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiOvertimeRulesetsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create overtime rulesets
 */
export const fetchPostApiOvertimeRulesets = (variables, signal) => sitFetch({ url: '/overtime-rulesets', method: 'post', ...variables, signal });
/**
 * Create overtime rulesets
 */
export const usePostApiOvertimeRulesets = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiOvertimeRulesets(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get employees assigned to overtime ruleset
 */
export const fetchGetApiOvertimeRulesetsEmployees = (variables, signal) => sitFetch({
    url: '/overtime-rulesets/employees',
    method: 'get',
    ...variables,
    signal,
});
export function getApiOvertimeRulesetsEmployeesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/overtime-rulesets/employees',
            operationId: 'getApiOvertimeRulesetsEmployees',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiOvertimeRulesetsEmployees(variables, signal),
    };
}
/**
 * Get employees assigned to overtime ruleset
 */
export const useGetApiOvertimeRulesetsEmployees = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiOvertimeRulesetsEmployeesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get predefined overtime rulesets
 */
export const fetchGetApiPredefinedOvertimeRulesets = (variables, signal) => sitFetch({
    url: '/overtime-rulesets/predefined',
    method: 'get',
    ...variables,
    signal,
});
export function getApiPredefinedOvertimeRulesetsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/overtime-rulesets/predefined',
            operationId: 'getApiPredefinedOvertimeRulesets',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiPredefinedOvertimeRulesets(variables, signal),
    };
}
/**
 * Get predefined overtime rulesets
 */
export const useGetApiPredefinedOvertimeRulesets = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiPredefinedOvertimeRulesetsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update overtime ruleset
 */
export const fetchPatchApiOvertimeRuleset = (variables, signal) => sitFetch({ url: '/overtime-rulesets/{id}', method: 'patch', ...variables, signal });
/**
 * Update overtime ruleset
 */
export const usePatchApiOvertimeRuleset = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiOvertimeRuleset(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete overtime rulesets
 */
export const fetchDeleteApiOvertimeRulesets = (variables, signal) => sitFetch({ url: '/overtime-rulesets/{id}', method: 'delete', ...variables, signal });
/**
 * Delete overtime rulesets
 */
export const useDeleteApiOvertimeRulesets = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiOvertimeRulesets(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Assign employees to overtime ruleset
 */
export const fetchPostApiOvertimeRulesetsAssignEmployees = (variables, signal) => sitFetch({
    url: '/overtime-rulesets/assign-employees',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Assign employees to overtime ruleset
 */
export const usePostApiOvertimeRulesetsAssignEmployees = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiOvertimeRulesetsAssignEmployees(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Unassign employees from overtime ruleset
 */
export const fetchPostApiOvertimeRulesetsUnassignEmployees = (variables, signal) => sitFetch({
    url: '/overtime-rulesets/unassign-employees',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Unassign employees from overtime ruleset
 */
export const usePostApiOvertimeRulesetsUnassignEmployees = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiOvertimeRulesetsUnassignEmployees(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get projects
 */
export const fetchGetApiProjects = (variables, signal) => sitFetch({ url: '/projects', method: 'get', ...variables, signal });
export function getApiProjectsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/projects',
            operationId: 'getApiProjects',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiProjects(variables, signal),
    };
}
/**
 * Get projects
 */
export const useGetApiProjects = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiProjectsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Forgot password
 */
export const fetchPostApiForgotPassword = (variables, signal) => sitFetch({ url: '/pub/forgot', method: 'post', ...variables, signal });
/**
 * Forgot password
 */
export const usePostApiForgotPassword = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiForgotPassword(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get Pub Intacct client ID
 */
export const fetchGetApiPubIntacctClientId = (variables, signal) => sitFetch({ url: '/pub/intacct-client-id', method: 'get', ...variables, signal });
export function getApiPubIntacctClientIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/pub/intacct-client-id',
            operationId: 'getApiPubIntacctClientId',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiPubIntacctClientId(variables, signal),
    };
}
/**
 * Get Pub Intacct client ID
 */
export const useGetApiPubIntacctClientId = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiPubIntacctClientIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Validate reset token
 */
export const fetchGetApiValidateResetToken = (variables, signal) => sitFetch({ url: '/pub/reset/{resetToken}', method: 'get', ...variables, signal });
export function getApiValidateResetTokenQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/pub/reset/{resetToken}',
            operationId: 'getApiValidateResetToken',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiValidateResetToken(variables, signal),
    };
}
/**
 * Validate reset token
 */
export const useGetApiValidateResetToken = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiValidateResetTokenQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Reset password
 */
export const fetchPostApiResetPassword = (variables, signal) => sitFetch({ url: '/pub/reset/{resetToken}', method: 'post', ...variables, signal });
/**
 * Reset password
 */
export const usePostApiResetPassword = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiResetPassword(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Post Api Pub Token
 */
export const fetchPostApiPubToken = (variables, signal) => sitFetch({ url: '/pub/token', method: 'post', ...variables, signal });
/**
 * Post Api Pub Token
 */
export const usePostApiPubToken = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiPubToken(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Returns the rate cards for the specified entity and the top level entity.
 * or only the top level if the company is a top level entity
 */
export const fetchGetApiRateCards = (variables, signal) => sitFetch({ url: '/ratecards', method: 'get', ...variables, signal });
export function getApiRateCardsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/ratecards',
            operationId: 'getApiRateCards',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiRateCards(variables, signal),
    };
}
/**
 * Returns the rate cards for the specified entity and the top level entity.
 * or only the top level if the company is a top level entity
 */
export const useGetApiRateCards = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiRateCardsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a new rate card
 */
export const fetchPostApiRateCard = (variables, signal) => sitFetch({ url: '/ratecards', method: 'post', ...variables, signal });
/**
 * Create a new rate card
 */
export const usePostApiRateCard = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiRateCard(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update a rate card
 */
export const fetchPutApiRateCard = (variables, signal) => sitFetch({ url: '/ratecards', method: 'put', ...variables, signal });
/**
 * Update a rate card
 */
export const usePutApiRateCard = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiRateCard(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete the specified rate card and all its entries
 */
export const fetchDeleteApiRateCard = (variables, signal) => sitFetch({ url: '/ratecards/{rateCardId}', method: 'delete', ...variables, signal });
/**
 * Delete the specified rate card and all its entries
 */
export const useDeleteApiRateCard = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiRateCard(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Duplicate a rate card with discount
 */
export const fetchPostApiDuplicateRateCardWithDiscount = (variables, signal) => sitFetch({ url: '/ratecards/{rateCardId}', method: 'post', ...variables, signal });
/**
 * Duplicate a rate card with discount
 */
export const usePostApiDuplicateRateCardWithDiscount = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiDuplicateRateCardWithDiscount(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Returns the rate card entries for the given rate card
 */
export const fetchGetApiRateCardEntries = (variables, signal) => sitFetch({
    url: '/ratecards/{rateCardId}/entries',
    method: 'get',
    ...variables,
    signal,
});
export function getApiRateCardEntriesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/ratecards/{rateCardId}/entries',
            operationId: 'getApiRateCardEntries',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiRateCardEntries(variables, signal),
    };
}
/**
 * Returns the rate card entries for the given rate card
 */
export const useGetApiRateCardEntries = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiRateCardEntriesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a new rate card entry
 */
export const fetchPostApiRateCardEntry = (variables, signal) => sitFetch({
    url: '/ratecards/{rateCardId}/entries',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Create a new rate card entry
 */
export const usePostApiRateCardEntry = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiRateCardEntry(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update a rate card entry
 */
export const fetchPutApiRateCardEntry = (variables, signal) => sitFetch({ url: '/ratecard-entries', method: 'put', ...variables, signal });
/**
 * Update a rate card entry
 */
export const usePutApiRateCardEntry = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiRateCardEntry(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete a rate card entry
 */
export const fetchDeleteApiRateCardEntry = (variables, signal) => sitFetch({ url: '/ratecard-entries/{id}', method: 'delete', ...variables, signal });
/**
 * Delete a rate card entry
 */
export const useDeleteApiRateCardEntry = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiRateCardEntry(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Health check endpoint for the API
 */
export const fetchGetApiServiceHealth = (variables, signal) => sitFetch({ url: '/service/health', method: 'get', ...variables, signal });
export function getApiServiceHealthQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/service/health',
            operationId: 'getApiServiceHealth',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiServiceHealth(variables, signal),
    };
}
/**
 * Health check endpoint for the API
 */
export const useGetApiServiceHealth = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiServiceHealthQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get tasks
 */
export const fetchGetApiTasks = (variables, signal) => sitFetch({ url: '/tasks', method: 'get', ...variables, signal });
export function getApiTasksQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/tasks',
            operationId: 'getApiTasks',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTasks(variables, signal),
    };
}
/**
 * Get tasks
 */
export const useGetApiTasks = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTasksQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get team
 */
export const fetchGetApiTeam = (variables, signal) => sitFetch({ url: '/team', method: 'get', ...variables, signal });
export function getApiTeamQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/team',
            operationId: 'getApiTeam',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTeam(variables, signal),
    };
}
/**
 * Get team
 */
export const useGetApiTeam = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTeamQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Invite team member
 */
export const fetchPostApiTeamByUuidInvite = (variables, signal) => sitFetch({ url: '/team/{teamId}/invite', method: 'post', ...variables, signal });
/**
 * Invite team member
 */
export const usePostApiTeamByUuidInvite = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTeamByUuidInvite(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Invite multiple team members
 */
export const fetchPostApiTeamBulkInvite = (variables, signal) => sitFetch({ url: '/team/bulk-invite', method: 'post', ...variables, signal });
/**
 * Invite multiple team members
 */
export const usePostApiTeamBulkInvite = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTeamBulkInvite(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get Api Time Assistant Download Links
 */
export const fetchGetApiTimeAssistantDownloadLinks = (variables, signal) => sitFetch({
    url: '/time-assistant/download-links',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimeAssistantDownloadLinksQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/time-assistant/download-links',
            operationId: 'getApiTimeAssistantDownloadLinks',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimeAssistantDownloadLinks(variables, signal),
    };
}
/**
 * Get Api Time Assistant Download Links
 */
export const useGetApiTimeAssistantDownloadLinks = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimeAssistantDownloadLinksQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Delete a time clock
 */
export const fetchDeleteApiTimeClocksId = (variables, signal) => sitFetch({ url: '/time-clocks', method: 'delete', ...variables, signal });
/**
 * Delete a time clock
 */
export const useDeleteApiTimeClocksId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiTimeClocksId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get time clocks
 */
export const fetchGetApiTimeClocks = (variables, signal) => sitFetch({ url: '/time-clocks', method: 'get', ...variables, signal });
export function getApiTimeClocksQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/time-clocks',
            operationId: 'getApiTimeClocks',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimeClocks(variables, signal),
    };
}
/**
 * Get time clocks
 */
export const useGetApiTimeClocks = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimeClocksQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a new time clock
 */
export const fetchPostApiTimeClocks = (variables, signal) => sitFetch({ url: '/time-clocks', method: 'post', ...variables, signal });
/**
 * Create a new time clock
 */
export const usePostApiTimeClocks = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimeClocks(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get active time clock
 */
export const fetchGetApiTimeClockActive = (variables, signal) => sitFetch({ url: '/time-clocks/active', method: 'get', ...variables, signal });
export function getApiTimeClockActiveQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/time-clocks/active',
            operationId: 'getApiTimeClockActive',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimeClockActive(variables, signal),
    };
}
/**
 * Get active time clock
 */
export const useGetApiTimeClockActive = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimeClockActiveQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get a time clock
 */
export const fetchGetApiTimeClocksId = (variables, signal) => sitFetch({ url: '/time-clocks/{id}', method: 'get', ...variables, signal });
export function getApiTimeClocksIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/time-clocks/{id}',
            operationId: 'getApiTimeClocksId',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimeClocksId(variables, signal),
    };
}
/**
 * Get a time clock
 */
export const useGetApiTimeClocksId = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimeClocksIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Patch a time clock
 */
export const fetchPatchApiTimeClocksId = (variables, signal) => sitFetch({ url: '/time-clocks/{id}', method: 'patch', ...variables, signal });
/**
 * Patch a time clock
 */
export const usePatchApiTimeClocksId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiTimeClocksId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Create a new time clock break
 */
export const fetchPostApiTimeClocksIdBreaks = (variables, signal) => sitFetch({ url: '/time-clocks/{id}/breaks', method: 'post', ...variables, signal });
/**
 * Create a new time clock break
 */
export const usePostApiTimeClocksIdBreaks = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimeClocksIdBreaks(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete a time clock break
 */
export const fetchDeleteApiTimeClocksIdBreaksBreakId = (variables, signal) => sitFetch({
    url: '/time-clocks/{id}/breaks/{breakId}',
    method: 'delete',
    ...variables,
    signal,
});
/**
 * Delete a time clock break
 */
export const useDeleteApiTimeClocksIdBreaksBreakId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiTimeClocksIdBreaksBreakId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Patch a time clock break
 */
export const fetchPatchApiTimeClocksIdBreaksBreakId = (variables, signal) => sitFetch({
    url: '/time-clocks/{id}/breaks/{breakId}',
    method: 'patch',
    ...variables,
    signal,
});
/**
 * Patch a time clock break
 */
export const usePatchApiTimeClocksIdBreaksBreakId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPatchApiTimeClocksIdBreaksBreakId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Set a dimension value for a time clock entry
 */
export const fetchPostApiTimeClocksIdDimensionValue = (variables, signal) => sitFetch({
    url: '/time-clocks/{id}/dimension-value',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Set a dimension value for a time clock entry
 */
export const usePostApiTimeClocksIdDimensionValue = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimeClocksIdDimensionValue(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Duplicate a time clock
 */
export const fetchPostApiTimeClocksIdDuplicate = (variables, signal) => sitFetch({
    url: '/time-clocks/{id}/duplicate',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Duplicate a time clock
 */
export const usePostApiTimeClocksIdDuplicate = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimeClocksIdDuplicate(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Split a time clock
 */
export const fetchPostApiTimeClocksIdSplit = (variables, signal) => sitFetch({ url: '/time-clocks/{id}/split', method: 'post', ...variables, signal });
/**
 * Split a time clock
 */
export const usePostApiTimeClocksIdSplit = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimeClocksIdSplit(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get time types
 */
export const fetchGetApiTimeTypes = (variables, signal) => sitFetch({ url: '/time-types', method: 'get', ...variables, signal });
export function getApiTimeTypesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/time-types',
            operationId: 'getApiTimeTypes',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimeTypes(variables, signal),
    };
}
/**
 * Get time types
 */
export const useGetApiTimeTypes = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimeTypesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get timesheets
 */
export const fetchGetApiTimesheets = (variables, signal) => sitFetch({ url: '/timesheets', method: 'get', ...variables, signal });
export function getApiTimesheetsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets',
            operationId: 'getApiTimesheets',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheets(variables, signal),
    };
}
/**
 * Get timesheets
 */
export const useGetApiTimesheets = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a new timesheet
 */
export const fetchPostApiTimesheets = (variables, signal) => sitFetch({ url: '/timesheets', method: 'post', ...variables, signal });
/**
 * Create a new timesheet
 */
export const usePostApiTimesheets = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheets(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete timesheet
 */
export const fetchPostApiTimesheetsDelete = (variables, signal) => sitFetch({ url: '/timesheets/delete', method: 'post', ...variables, signal });
/**
 * Delete timesheet
 */
export const usePostApiTimesheetsDelete = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsDelete(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get timesheet
 */
export const fetchGetApiTimesheetsByUuid = (variables, signal) => sitFetch({ url: '/timesheets/{id}', method: 'get', ...variables, signal });
export function getApiTimesheetsByUuidQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}',
            operationId: 'getApiTimesheetsByUuid',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsByUuid(variables, signal),
    };
}
/**
 * Get timesheet
 */
export const useGetApiTimesheetsByUuid = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsByUuidQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update timesheet
 */
export const fetchPutApiTimesheetsByUuid = (variables, signal) => sitFetch({ url: '/timesheets/{id}', method: 'put', ...variables, signal });
/**
 * Update timesheet
 */
export const usePutApiTimesheetsByUuid = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuid(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * List attachments for a timesheet
 */
export const fetchGetApiTimesheetsAttachmentByUuid = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/attachments',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetsAttachmentByUuidQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/attachments',
            operationId: 'getApiTimesheetsAttachmentByUuid',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsAttachmentByUuid(variables, signal),
    };
}
/**
 * List attachments for a timesheet
 */
export const useGetApiTimesheetsAttachmentByUuid = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsAttachmentByUuidQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create (and update) a timesheet attachment
 */
export const fetchPostApiTimesheetsAttachmentByUuid = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/attachments',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Create (and update) a timesheet attachment
 */
export const usePostApiTimesheetsAttachmentByUuid = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsAttachmentByUuid(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Delete a timesheet attachment
 */
export const fetchDeleteApiTimesheetsAttachmentByUuid = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/attachments',
    method: 'delete',
    ...variables,
    signal,
});
/**
 * Delete a timesheet attachment
 */
export const useDeleteApiTimesheetsAttachmentByUuid = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiTimesheetsAttachmentByUuid(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Download a timesheet attachment file
 */
export const fetchGetApiTimesheetAttachmentFile = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/attachments/download',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetAttachmentFileQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/attachments/download',
            operationId: 'getApiTimesheetAttachmentFile',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetAttachmentFile(variables, signal),
    };
}
/**
 * Download a timesheet attachment file
 */
export const useGetApiTimesheetAttachmentFile = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetAttachmentFileQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Get a SIT timesheet ID by Intacct Entity ID and External Unique ID (used in embedded)
 */
export const fetchGetApiTimesheetsByExternalUniqueId = (variables, signal) => sitFetch({
    url: '/timesheets/external-unique-id/{intacctEntityId}/{externalUniqueId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetsByExternalUniqueIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/external-unique-id/{intacctEntityId}/{externalUniqueId}',
            operationId: 'getApiTimesheetsByExternalUniqueId',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsByExternalUniqueId(variables, signal),
    };
}
/**
 * Get a SIT timesheet ID by Intacct Entity ID and External Unique ID (used in embedded)
 */
export const useGetApiTimesheetsByExternalUniqueId = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsByExternalUniqueIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Duplicate a timesheet
 */
export const fetchPostApiTimesheetsDuplicate = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/duplicate',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Duplicate a timesheet
 */
export const usePostApiTimesheetsDuplicate = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsDuplicate(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get timesheet entries for timesheet
 */
export const fetchGetApiTimesheetsByUuidEntries = (variables, signal) => sitFetch({ url: '/timesheets/{id}/entries', method: 'get', ...variables, signal });
export function getApiTimesheetsByUuidEntriesQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/entries',
            operationId: 'getApiTimesheetsByUuidEntries',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsByUuidEntries(variables, signal),
    };
}
/**
 * Get timesheet entries for timesheet
 */
export const useGetApiTimesheetsByUuidEntries = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsByUuidEntriesQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a timesheet entry
 */
export const fetchPostApiTimesheetsByUuidEntries = (variables, signal) => sitFetch({ url: '/timesheets/{id}/entries', method: 'post', ...variables, signal });
/**
 * Create a timesheet entry
 */
export const usePostApiTimesheetsByUuidEntries = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsByUuidEntries(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get a timesheet entry
 */
export const fetchGetApiTimesheetsEntryById = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/entries/{entryId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetsEntryByIdQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/entries/{entryId}',
            operationId: 'getApiTimesheetsEntryById',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsEntryById(variables, signal),
    };
}
/**
 * Get a timesheet entry
 */
export const useGetApiTimesheetsEntryById = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsEntryByIdQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create a timesheet entry
 */
export const fetchPutApiTimesheetsByUuidEntriesByEntryId = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/entries/{entryId}',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Create a timesheet entry
 */
export const usePutApiTimesheetsByUuidEntriesByEntryId = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuidEntriesByEntryId(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Check whether approve and declined are allowed for a specific entry
 */
export const fetchGetApiTimesheetsEntryApproveDeclineAllowed = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/entries/{entryId}/approve-decline-allowed',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetsEntryApproveDeclineAllowedQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/entries/{entryId}/approve-decline-allowed',
            operationId: 'getApiTimesheetsEntryApproveDeclineAllowed',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsEntryApproveDeclineAllowed(variables, signal),
    };
}
/**
 * Check whether approve and declined are allowed for a specific entry
 */
export const useGetApiTimesheetsEntryApproveDeclineAllowed = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsEntryApproveDeclineAllowedQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Recall timesheet
 */
export const fetchPostApiTimesheetsByUuidRecall = (variables, signal) => sitFetch({ url: '/timesheets/{id}/recall', method: 'post', ...variables, signal });
/**
 * Recall timesheet
 */
export const usePostApiTimesheetsByUuidRecall = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsByUuidRecall(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get timesheet rows for timesheet
 */
export const fetchGetApiTimesheetsByUuidRows = (variables, signal) => sitFetch({ url: '/timesheets/{id}/rows', method: 'get', ...variables, signal });
export function getApiTimesheetsByUuidRowsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/rows',
            operationId: 'getApiTimesheetsByUuidRows',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetsByUuidRows(variables, signal),
    };
}
/**
 * Get timesheet rows for timesheet
 */
export const useGetApiTimesheetsByUuidRows = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetsByUuidRowsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Create timesheet row
 */
export const fetchPostApiTimesheetsByUuidRows = (variables, signal) => sitFetch({ url: '/timesheets/{id}/rows', method: 'post', ...variables, signal });
/**
 * Create timesheet row
 */
export const usePostApiTimesheetsByUuidRows = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsByUuidRows(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get timesheet row with autofills
 */
export const fetchGetApiTimesheetRow = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}',
    method: 'get',
    ...variables,
    signal,
});
export function getApiTimesheetRowQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/timesheets/{id}/rows/{timesheetRowId}',
            operationId: 'getApiTimesheetRow',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiTimesheetRow(variables, signal),
    };
}
/**
 * Get timesheet row with autofills
 */
export const useGetApiTimesheetRow = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiTimesheetRowQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Delete timesheet row
 */
export const fetchDeleteApiTimesheetsByUuidRows = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}',
    method: 'delete',
    ...variables,
    signal,
});
/**
 * Delete timesheet row
 */
export const useDeleteApiTimesheetsByUuidRows = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchDeleteApiTimesheetsByUuidRows(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * This endpoint is deprecated. Use `PUT /timesheets/{id}/rows/{timesheetRowId}/dimension-values` instead.
 */
export const fetchPutApiTimesheetsByUuidRows = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}',
    method: 'put',
    ...variables,
    signal,
});
/**
 * This endpoint is deprecated. Use `PUT /timesheets/{id}/rows/{timesheetRowId}/dimension-values` instead.
 */
export const usePutApiTimesheetsByUuidRows = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuidRows(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update timesheet row billable
 */
export const fetchPutApiTimesheetsByUuidRowsBillable = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}/billable',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Update timesheet row billable
 */
export const usePutApiTimesheetsByUuidRowsBillable = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuidRowsBillable(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update timesheet row dimension values
 */
export const fetchPutApiTimesheetsByUuidRowsDimensionValues = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}/dimension-values',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Update timesheet row dimension values
 */
export const usePutApiTimesheetsByUuidRowsDimensionValues = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuidRowsDimensionValues(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update a single dimension value for a timesheet row
 */
export const fetchPutApiTimesheetsByUuidRowsDimensionValue = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/rows/{timesheetRowId}/dimension-value',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Update a single dimension value for a timesheet row
 */
export const usePutApiTimesheetsByUuidRowsDimensionValue = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiTimesheetsByUuidRowsDimensionValue(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Save timesheet using a background job
 */
export const fetchPostApiTimesheetsByUuidSaveAsync = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/save-async',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Save timesheet using a background job
 */
export const usePostApiTimesheetsByUuidSaveAsync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsByUuidSaveAsync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Submit timesheet using a background job
 */
export const fetchPostApiTimesheetsByUuidSubmitAsync = (variables, signal) => sitFetch({
    url: '/timesheets/{id}/submit-async',
    method: 'post',
    ...variables,
    signal,
});
/**
 * Submit timesheet using a background job
 */
export const usePostApiTimesheetsByUuidSubmitAsync = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiTimesheetsByUuidSubmitAsync(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Save whether the user has downloaded the Time Assistant
 */
export const fetchPutApiUserActions = (variables, signal) => sitFetch({ url: '/user-actions', method: 'put', ...variables, signal });
/**
 * Save whether the user has downloaded the Time Assistant
 */
export const usePutApiUserActions = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiUserActions(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Record user consents
 */
export const fetchPostApiUserConsents = (variables, signal) => sitFetch({ url: '/user-consents', method: 'post', ...variables, signal });
/**
 * Record user consents
 */
export const usePostApiUserConsents = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUserConsents(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Revoke user's consent for either email or push
 */
export const fetchPostApiUserConsentsRevoke = (variables, signal) => sitFetch({ url: '/user-consents/revoke', method: 'post', ...variables, signal });
/**
 * Revoke user's consent for either email or push
 */
export const usePostApiUserConsentsRevoke = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUserConsentsRevoke(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get user notification settings
 */
export const fetchGetApiUserNotificationSettings = (variables, signal) => sitFetch({
    url: '/user-notification-settings',
    method: 'get',
    ...variables,
    signal,
});
export function getApiUserNotificationSettingsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/user-notification-settings',
            operationId: 'getApiUserNotificationSettings',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiUserNotificationSettings(variables, signal),
    };
}
/**
 * Get user notification settings
 */
export const useGetApiUserNotificationSettings = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiUserNotificationSettingsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update user notification settings
 */
export const fetchPutApiUserNotificationSettings = (variables, signal) => sitFetch({
    url: '/user-notification-settings',
    method: 'put',
    ...variables,
    signal,
});
/**
 * Update user notification settings
 */
export const usePutApiUserNotificationSettings = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiUserNotificationSettings(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get user settings
 */
export const fetchGetApiUserSettings = (variables, signal) => sitFetch({ url: '/user-settings', method: 'get', ...variables, signal });
export function getApiUserSettingsQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/user-settings',
            operationId: 'getApiUserSettings',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiUserSettings(variables, signal),
    };
}
/**
 * Get user settings
 */
export const useGetApiUserSettings = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiUserSettingsQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Update user settings
 */
export const fetchPutApiUserSettings = (variables, signal) => sitFetch({ url: '/user-settings', method: 'put', ...variables, signal });
/**
 * Update user settings
 */
export const usePutApiUserSettings = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiUserSettings(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Get current user
 */
export const fetchGetApiUser = (variables, signal) => sitFetch({ url: '/users', method: 'get', ...variables, signal });
export function getApiUserQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/users',
            operationId: 'getApiUser',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiUser(variables, signal),
    };
}
/**
 * Get current user
 */
export const useGetApiUser = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiUserQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * List users
 */
export const fetchGetApiUsers = (variables, signal) => sitFetch({ url: '/users/list', method: 'get', ...variables, signal });
export function getApiUsersQuery(variables) {
    return {
        queryKey: queryKeyFn({
            path: '/users/list',
            operationId: 'getApiUsers',
            variables,
        }),
        queryFn: variables === reactQuery.skipToken
            ? reactQuery.skipToken
            : ({ signal }) => fetchGetApiUsers(variables, signal),
    };
}
/**
 * List users
 */
export const useGetApiUsers = (variables, options) => {
    const { queryOptions, fetcherOptions } = useSitContext(options);
    return reactQuery.useQuery({
        ...getApiUsersQuery(variables === reactQuery.skipToken
            ? variables
            : deepMerge(fetcherOptions, variables)),
        ...options,
        ...queryOptions,
    });
};
/**
 * Logout
 */
export const fetchPostApiUsersLogout = (variables, signal) => sitFetch({ url: '/users/logout', method: 'post', ...variables, signal });
/**
 * Logout
 */
export const usePostApiUsersLogout = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersLogout(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Update user
 */
export const fetchPutApiUsersByUuid = (variables, signal) => sitFetch({ url: '/users/{userId}', method: 'put', ...variables, signal });
/**
 * Update user
 */
export const usePutApiUsersByUuid = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPutApiUsersByUuid(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Activate 2FA
 */
export const fetchPostApiUsersActivate2Fa = (variables, signal) => sitFetch({ url: '/users/activate2fa', method: 'post', ...variables, signal });
/**
 * Activate 2FA
 */
export const usePostApiUsersActivate2Fa = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersActivate2Fa(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Change password
 */
export const fetchPostApiUsersChangePassword = (variables, signal) => sitFetch({ url: '/users/change-password', method: 'post', ...variables, signal });
/**
 * Change password
 */
export const usePostApiUsersChangePassword = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersChangePassword(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Deactivate 2FA
 */
export const fetchPostApiUsersDeactivate2Fa = (variables, signal) => sitFetch({ url: '/users/deactivate2fa', method: 'post', ...variables, signal });
/**
 * Deactivate 2FA
 */
export const usePostApiUsersDeactivate2Fa = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersDeactivate2Fa(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Verify password (during MFA initialization)
 */
export const fetchPostApiUsersVerifyPassword = (variables, signal) => sitFetch({ url: '/users/verify-password', method: 'post', ...variables, signal });
/**
 * Verify password (during MFA initialization)
 */
export const usePostApiUsersVerifyPassword = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersVerifyPassword(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
/**
 * Verify 2FA
 */
export const fetchPostApiUsersVerify2Fa = (variables, signal) => sitFetch({ url: '/users/verify2fa', method: 'post', ...variables, signal });
/**
 * Verify 2FA
 */
export const usePostApiUsersVerify2Fa = (options) => {
    const { fetcherOptions } = useSitContext();
    return reactQuery.useMutation({
        mutationFn: (variables) => fetchPostApiUsersVerify2Fa(deepMerge(fetcherOptions, variables)),
        ...options,
    });
};
//# sourceMappingURL=sitComponents.js.map